import { payTypeCode } from "@/assets/js/config/payTypeMap"

const answerSheetListSearchFields = [
  {
    label: '结算状态',
    prop: 'settleStatus',
    type: 'select',
    originvalue: [],
    value: 0,
    options: [
      {
        label: '未结算',
        value: 0
      },
      {
        label: '正在结算',
        value: 1
      },
      {
        label: '已结算',
        value: 2
      },
      {
        label: '全部',
        value: null
      }
    ]
  },
  {
    label: '代理/代理ID/任务ID/答卷ID',
    prop: 'keyword',
    type: 'input',
    originvalue: '',
    value: ''
  }
]

const settlementListSearchFields = [
  {
    label: '结算单状态',
    prop: 'settleStatus',
    type: 'select',
    originvalue: [],
    value: [],
    options: [
      {
        label: '未发起',
        value: 1
      },
      {
        label: '待确认',
        value: 2
      },
      {
        label: '不认可',
        value: 3
      },
      {
        label: '已确认',
        value: 4
      },
      {
        label: '已撤销',
        value: 5
      },
      {
        label: '已结算',
        value: 6
      },
      {
        label: '已打款',
        value: 7
      },
      {
        label: '审批中',
        value: 8
      },
      {
        label: '审批已撤销',
        value: 9
      },
      {
        label: '审批拒绝',
        value: 10
      },
      {
        label: '全部',
        value: null
      }
    ]
  },
  {
    label: '支付方式',
    prop: 'payType',
    type: 'select',
    originvalue: [],
    value: [],
    options: [{
      label: '线下支付', value: payTypeCode['线下支付']
    }, {
      label: '线上支付', value: payTypeCode['线上支付']
    },{
      label: '全部', value: null
    }]
  },
  {
    label: '代理/代理ID/任务ID/结算单号',
    prop: 'keyword',
    type: 'input',
    originvalue: '',
    value: ''
  }
]

answerSheetListSearchFields.forEach(filterItem => {
  filterItem.lg = 5
  filterItem.sm = 24
  filterItem.md = 8
})
settlementListSearchFields.forEach(filterItem => {
  if (filterItem.prop == 'keyword') {
    filterItem.lg = 8
    filterItem.sm = 24
    filterItem.md = 8
  } else {
    filterItem.lg = 5
    filterItem.sm = 24
    filterItem.md = 8
  }
})
export { answerSheetListSearchFields, settlementListSearchFields }
